import { Component, ElementRef, HostListener, inject, Input, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ServicesService } from '../my-profile/services.service';
import { UserDetailsService } from '../services/user-details.service';
import { ApiServicesService } from '../services/api-services.service';
import { MatDialog } from '@angular/material/dialog';
import { ImageModalComponent } from '../image-modal/image-modal.component';
import { SnackbarService } from '../services/snackbar.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-user-photos',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './user-photos.component.html',
  styleUrl: './user-photos.component.css'
})
export class UserPhotosComponent {

  is_openphotos = 'Media';
  baseUrl: string = 'http://localhost:4200';
  post_images: any[] = []
  is_myProfile: boolean = false;
  userData: any = {};
  loader: boolean = true;
  loader2: boolean = true;
  album_id: any = '';
  page: any = 1;
  limit: any = 6;
  totalPages: any = 1;
  isLoading: any = false;
  shimmer:any;
  private taskservices = inject(ServicesService);


  @Input() public set albumId(value: any) {
    if (value !== '' && value !== null && value !== undefined) {
      this.album_id = value;
    } else {
      this.album_id = '';
    }
  }

  constructor(private userdetails: UserDetailsService, public apiservices: ApiServicesService, private dialog: MatDialog, private snackbarService: SnackbarService) { }

  viewPhotos() {
    if (this.is_myProfile) {
      this.taskservices.close_task(this.is_openphotos)
    } else {
      this.taskservices.isViewSubject.next("Media");
    }
  }
  private subscription!: Subscription;

  @Input() show_title: boolean = true;
  showErrorMessage: boolean = false;
  private photoDetailsSubscription!: Subscription;

  ngOnInit() {
    this.photoDetailsSubscription = this.userdetails.userdetails$.subscribe((userData) => {
      if (userData !== null) {
        if (userData) {
          this.userData = userData;
          if (this.userData?.user?._id) {
            this.loader2 = false;
            this.loader = true;
            this.getPhotos(1, 9);
            this.is_myProfile = this.apiservices.checkProfile(this.userData?.user?.username);
          }
        } else {
          this.loader = true;
          this.loader2 = true;
        }
      }
    });

    this.subscription = this.userdetails.photos$.subscribe((res) => {
      if (res) {
        if (this.userData?.user?._id) {
          this.loader = true;
          this.getPhotos(1, 9);
        }
      }
    });
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.photoDetailsSubscription) {
      this.photoDetailsSubscription.unsubscribe();
    }
  }

  getPhotos(page: any, limit: any) {
    this.shimmer=true;
    this.showErrorMessage = false;
    this.apiservices.getPhotos(this.userData?.user?._id, this.album_id, page, limit).subscribe({
      next: (photos: any) => {
        // console.log('photos',photos)
        this.loader = false;
        this.shimmer=false;
        if (photos.status == 200) {
          if (page == 1) {
            this.post_images = photos?.photos || [];
          } else {
            this.post_images = [...this.post_images, ...photos.photos];
          }
          this.page = photos.pagination?.currentPage || 1;
          this.totalPages = photos.pagination?.totalPages || 1;
          this.isLoading = false;
        } else {
          this.isLoading = false;
          this.post_images = photos?.photos || [];
          if (photos.message == "Access restricted. You are not friends with this user." || photos.message == "Album is private." || photos.message == "You and the target user are not friends.") {
            this.showErrorMessage = true;
          }
        }

        if(photos.message=='Your account is inactive. Cannot perform this action.'){
          this.snackbarService.openCustomSnackbar(
            {
              icon: false,
              message: photos.message,
              className: 'failed',
            }
          );
        }

        
      },
      error: (err) => {
        this.shimmer=false;
        this.loader = false;
        this.post_images = [];
        this.page = 1;
        this.totalPages = 1;
        this.snackbarService.openCustomSnackbar(
          {
            icon: false,
            message: err.error.message,
            className: 'failed',
          }
        );
      }
    });
  }

  // @HostListener('window:scroll', ['$event'])
  // onScroll(): void {
  //   const scrollTop = window.scrollY || document.documentElement.scrollTop;
  //   const scrollHeight = document.documentElement.scrollHeight;
  //   const clientHeight = document.documentElement.clientHeight;
  
  //   if (scrollTop + clientHeight >= scrollHeight - 10) { // When near bottom
  //     if (this.page < this.totalPages && !this.isLoading && !this.show_title) {
  //       this.page++;
  //       this.getPhotos(this.page, this.limit);
  //     }
  //   }
  // }




  
    @ViewChild('scrollContainer', { static: true }) scrollContainer!: ElementRef;
    @HostListener('window:scroll', ['$event'])
    onScroll(event: Event): void {
      if (!this.scrollContainer) return;
    
      const target = this.scrollContainer.nativeElement as HTMLElement;
      const rect = target.getBoundingClientRect(); // Get element position relative to the viewport
      const windowHeight = window.innerHeight;
    
      // Check if the element is visible near the bottom of the viewport
      if (rect.bottom <= windowHeight + 100 && !this.isLoading && !this.show_title && this.page < this.totalPages) {
        // this.shimmer = true;
        this.isLoading = true;
        this.page++;
              this.getPhotos(this.page, this.limit);
       
      }
    }
  



  // onScroll(event: Event): void {
  //   const target = event.target as Document;
  //   const scrollTop = target.scrollingElement?.scrollTop || 0;
  //   const innerHeight = window.innerHeight;
  //   const scrollHeight = target.scrollingElement?.scrollHeight || 0;
  //   if (
  //     innerHeight + scrollTop >= scrollHeight - 100 && !this.isLoading && this.show_title && (this.page < this.totalPages) && this.totalPages > 1) {
  //       this.isLoading=true;
  //       this.page++;
  //       // this.page++;
  //     this.getPhotos(this.page, this.limit);
  //       // console.log("page number in scroll",this.page)
       
  //   }
  // }



  openImageModal(imageUrl: string): void {
    this.dialog.open(ImageModalComponent, {
      data: { imageUrl },
    });
  }

  removeImg(id: any) {
    this.apiservices.deletePhotos(id, this.album_id).subscribe({
      next: (response) => {
        this.snackbarService.openCustomSnackbar(
          {
            icon: true,
            message: response.message,
            className: 'success',
          }
        );
        this.getPhotos(1, 9);
      },
      error: (err) => {

      }
    })
  }

}
